"use strict";

exports.__esModule = true;
var _News = _interopRequireDefault(require("./News"));
exports.default = _News.default;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}